import { Offer } from '../../../common/models/offer';
import { OfferCompleteStatus } from '../../../common/models/enums/offer-complete-status';
import { OfferStatus } from '../../../common/models/enums/offer-status';
import { PriceCalculation } from '../models/price-calculation';

const getBestOfferId = (offers: Offer[]): number => {
    if (!offers || offers.length === 0) {
        return -1;
    }

    let bestTotal = Infinity;
    let bestOfferId = -1;
    offers.forEach(offer => {
        if (
            (offer.status === OfferStatus.Pending || offer.status === OfferStatus.Accepted) &&
            offer.completeStatus !== OfferCompleteStatus.Incomplete
        ) {
            const offerTotal = offer.getTotalWithCosts();
            if (offerTotal < bestTotal) {
                bestTotal = offerTotal;
                bestOfferId = offer.id;
            }
        }
    });
    return bestOfferId;
};

const getRecommendationId = (offers: Offer[]): number | undefined => {
    if (!offers || offers.length === 0) {
        return undefined;
    }

    const recommendedOffer = offers.find(offer => offer.isRecommended);
    const recommendationId = recommendedOffer && recommendedOffer.id;
    return recommendationId;
};

export const getPriceCalculation = (offers?: Offer[]): PriceCalculation => {
    if (!offers || offers.length === 0) {
        return { bestOfferId: -1, recommendationId: -1 };
    }

    const bestOfferId = getBestOfferId(offers);
    const recommendationId = getRecommendationId(offers);
    return {
        bestOfferId,
        recommendationId,
    };
};
